const getProductRewardPoints = `
    query ProductRewardPoints($product_uid: String!, $vip_guest: Boolean) {
        getProductRewardPoints(product_uid: $product_uid, vip_guest: $vip_guest) {
            bwfo_cash {
                value
                currency
            }
            vip_bwfo_cash {
                value
                currency
            }
        }
    }
`;

const customer = `{
    customer {
        custom_attributes(attributeCodes: ["vip_status"]) {
            code
            ... on AttributeSelectedOptions {
                selected_options {
                    value
                    label
                }
            }
        }
        email
    }
}`;

const setVipStatusOpt = `
    mutation SetVipStatusOpt($input: SetCustomOptInput) {
        setVipStatusOpt(input: $input)
    }
`;


export default {
    getProductRewardPoints,
    customer,
    setVipStatusOpt,
};
